const Stomp = require('../../node_modules/webstomp-client/dist/webstomp.js');
angular.module('Const').constant('Stomp', Stomp);


// WEBPACK FOOTER //
// ./js/consts/webstompClient.js